import axios from "axios";
import React, {useEffect, useState,useRef} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../pages/Master_Front";

import "../../components/assets/css/profile.css"

import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Menu_panel from "../../components/layaout/Menu-panel";

import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import LazyLoad from "react-lazy-load";
import banner from "../../assets/img/Rectangle 305.png";



const serialize = require('form-serialize');


const Change_password = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [list_order_get,setData_list_order] = useState([]);
    /*  end profile */

    const [password,setPassword] = useState('');
    const [password_confirm,setPassword_confirm] = useState('');

    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); 
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {

        if(check_login_appbk()==false){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); } 

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");

        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`,null,config)
            .then((res) => {
///console.log(res.data);
                Setloadinghkfullshow("false");
                if(String(res.data).length > 0) {

                    if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );   } ////dddddd

                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                  ///  if(String(res.data.data.total_cource_order).length  > 0) {  setData_total_cource_order(res.data.data.total_cource_order); }
                 if(String(res.data.data.list_order).length > 0) {  setData_list_order(res.data.data.list_order); }







                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
             Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }


    const password_Handler=(event)=>{
        setPassword(convert_to_english_strhk(event.target.value));
    }
    const password_confirm_Handler=(event)=>{
        setPassword_confirm(convert_to_english_strhk(event.target.value));
    }


    const Handler_Change_password= () => {


        if(check_login_appbk()==false){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }



        if (password === '') {
            toast.error('رمز عبور وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            /// setErrorMessage('password empty');
            return false;

        }


            const config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };

        Setloadinghkfullshow("true");

            const data_form = {password_new:password,password_confirm:password_confirm};
            Setloadinghkfullshow("true");
            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/change-password`,data_form,config)
                .then((res) => {
///console.log(res.data);


                    Setloadinghkfullshow("false");

                    if (res.data.data=="change_password_success") {



                        setPassword('');
                        if(String(res.data.msgwebapp).length > 0){
                            toast.success(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

                        }


                    }else{
                        if(String(res.data.msgwebapp).length > 0){    toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,}); }
                    }

                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 675672', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });






    }



    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />
                <ToastContainer />


                <img src={banner} alt="banner" className='baner-panel'/>

                <section className='w-100 flexRowBetStart account-section-container'>




                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                        <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"4px"}}>


                            <div className='account-aside'>
                                <Menu_panel wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} />
                            </div>

                        </Grid>


                        <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>

                            <section className='account-content'>

                                <div className={"title_page_panel"} style={{width: '100%',"marginBottom":"0px", paddingBottom: '0px', display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div ><span style={{"color":"var(--c7)","fontFamily":"iran","fontSize":"19px","fontStyle":"normal","fontWeight":"700","lineHeight":"normal","paddingTop":"35px","display":"block","paddingBottom":"28px"}}>تغییر رمز عبور</span></div>
                                </div>


                                <div className='w-100 flexRowBetCenter'>

                                    <form id="form_data_profile">

                                        <div style={{"padding":"12px","width":"100%"}}>
                                            <Grid container direction="row" spacing={2} style={{paddingTop:"5px"}}>



                                                <Grid  item className="item_inputbk" lg={4} md={4} sm={12} xs={12} style={{marginTop:"7px"}}>
                                                    <label className={"lable_input_panel requirebk-input"} id={"last_name"} >رمز عبور</label>
                                                    <input value={password} onChange={password_Handler}   type="text" className="inputbox_bk_panel" name="password_new"   />
                                                </Grid>



                                                <Grid  item className="item_inputbk" lg={4} md={4} sm={12} xs={12} style={{marginTop:"8px",marginBottom:"0px"}}>
                                                    <label  id={"email_address_user"} className={"lable_input_panel requirebk-input"}>تکرار رمز عبور</label>
                                                    <input value={password_confirm} onChange={password_confirm_Handler}   type="text" className="inputbox_bk_panel" name="password_confirm"  />
                                                </Grid>


                                            </Grid>

                                            <button   type="button"  onClick={Handler_Change_password} className="btn-bh btn-bon-bh" style={{"height":"45px","marginTop":"31px","fontFamily":"'iran'","fontSize":"17px"}} >ذخیره</button>



                                        </div>
                                    </form>

                                </div>

                            </section>


                        </Grid>






                    </Grid>






                </section>










            </Master_Front>

        </>
    );
}


export default Change_password;